import * as service from './calender.service'

export default {
  data() {
    return {
      events: [],
      config: {
        header: {
          right: 'month'
        },
        edit: false,
        editable: false,
        stick: true,
        defaultView: 'month',
        events: [{
            title: 'Mermaid Races',
            start: '2017-11-01',
          },
          {
            title: 'Swimming Lessons',
            start: '2017-11-07',
            end: '2017-11-10'
          },
          {
            title: 'Kayak Training',
            start: '2017-11-11',
            end: '2017-11-13'
          },

        ]

      },
      eventDetails: [{
        'ActivityTypeDesc': '',
        'ProgramName': '',
        'Description': '',
        'StartDate': '',
        'EndDate': '',
        'MondayEnd': '',
        'MondayStart': '',
        'TuesdayEnd': '',
        'TuesdayStart': '',
        'WednesdayEnd': '',
        'WednesdayStart': '',
        'ThursdayEnd': '',
        'ThursdayStart': '',
        'FridayEnd': '',
        'FridayStart': '',
        'SaturdayEnd': '',
        'SaturdayStart': '',
        'SundayEnd': '',
        'SundayStart': '',

      }],
      Locations: [],
      Pools: [],
      locationId: '',
      poolId: '',

    }
  },

  mounted() {
    var cur_d = this.$moment().format('ddd');
    var cur_n = this.$moment().format('DD');

    var curr_month_year = this.$moment().month('M').format('MMMM')
    var curr_year = this.$moment().format('Y')
    $('#current_month h2').text(curr_month_year + '  ' + ' ' + curr_year)

    $('#curr_day').html('<span>' + cur_d + '</span>');
    $('#curre_dt').html('<span>' + cur_n + '</span><div class="ev_day"><span>Mermaid Races</span><br><span>Venue - Main Pool</span></div>');
    var curr_3 = this.$moment().subtract(1, 'days');
    var curr_2 = this.$moment().subtract(2, 'days');
    var curr_1 = this.$moment().subtract(3, 'days');
    var curr_4 = this.$moment().add(1, 'days');
    var curr_5 = this.$moment().add(2, 'days');
    var curr_6 = this.$moment().add(3, 'days');
    $('#curr_3').html('<span>' + this.$moment(curr_3).format('DD') + '</span>');
    $('#curr_d_3').html('<span>' + this.$moment(curr_3).format('ddd') + '</span>');

    $('#curr_2').html('<span>' + this.$moment(curr_2).format('DD') + '</span>');
    $('#curr_d_2').html('<span>' + this.$moment(curr_2).format('ddd') + '</span>');

    $('#curr_1').html('<span>' + this.$moment(curr_1).format('DD') + '</span>');
    $('#curr_d_1').html('<span>' + this.$moment(curr_1).format('ddd') + '</span>');

    $('#curr_4').html('<span>' + this.$moment(curr_4).format('DD') + '</span>');
    $('#curr_d_4').html('<span>' + this.$moment(curr_4).format('ddd') + '</span>');

    $('#curr_5').html('<span>' + this.$moment(curr_5).format('DD') + '</span>');
    $('#curr_d_5').html('<span>' + this.$moment(curr_5).format('ddd') + '</span>');

    $('#curr_6').html('<span>' + this.$moment(curr_6).format('DD') + '</span>');
    $('#curr_d_6').html('<span>' + this.$moment(curr_6).format('ddd') + '</span>');

  },
  methods: {
    GetActivities(locid) {
      services.GetAllActivity(49).then(
        function (response) {

        }
      )
    }

  }




}



// WEBPACK FOOTER //
// ./src/components/DashboardCalender/calender.controller.js